import type { ElementType, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Link } from '../../../Link'
import { TypographyV2 } from '../../Foundations/Typography'
import styles from './ContentType.module.scss'

export const ContentType: FunctionComponent<Props> = ({
  text,
  link,
  icon: Icon,
}) => {
  const hasIcon = !!Icon
  const hasLink = link ? true : false

  return (
    <div className={styles.contentType}>
      {hasIcon && (
        <div className={styles.contentTypeIcon} data-testid="content-type-icon">
          <Icon />
        </div>
      )}
      <span
        className={classnames(styles.contentTypeText, {
          [styles.contentTypeTextHasLink]: hasLink,
        })}
      >
        <TypographyV2
          dataTestId="content-type-text"
          textStyle="sb-text-interface-body-x-small-regular"
          tag="span"
        >
          {link ? (
            <Link appearance={'secondary'} href={link} checkIsExternal={false}>
              {text}
            </Link>
          ) : (
            text
          )}
        </TypographyV2>
      </span>

      {link && (
        <Link
          aria-label={text}
          className={styles.contentTypeLink}
          href={link}
          checkIsExternal={false}
          tabIndex={0}
        />
      )}
    </div>
  )
}
export type Props = {
  /**
   * Icon - Element Type
   */
  icon: ElementType
  /**
   * Text String
   */
  text: string
  /**
   * Link
   */
  link?: string
}
